import { BannerSection, SectionSubtitle, TBannerSectionDirection } from '@web_opxp/components';
import { ETagType, renderStringToReact, useTranslation } from '@web_opxp/language';
import * as React from 'react';
import { AssetsBaseUrl } from '../../base/env';

export interface IProps {
  blogUrl: string;
  bannerDirection?: TBannerSectionDirection;
  onLearnMore?: () => void;
}

const ScienceSection: React.FC<IProps> = ({ blogUrl, onLearnMore, bannerDirection }) => {
  const { t } = useTranslation();
  const title = t('prereg:Welcome.ScienceSection.Title');
  const descriptionHtml = t('prereg:Welcome.ScienceSection.DescriptionHtml');
  const imgSrc = `${AssetsBaseUrl}/feature/science.png`;
  return (
    <BannerSection direction={bannerDirection ?? 'left'} title={title} imgSrc={imgSrc}>
      <SectionSubtitle wrapperTag="div">{renderStringToReact(descriptionHtml, ETagType.div)}</SectionSubtitle>
      <a href={blogUrl} onClick={onLearnMore}>
        {t('prereg:Welcome.ScienceSection.Action')}
      </a>
    </BannerSection>
  );
};

export default ScienceSection;
